/**
 * Construction - All Works Page
 * Construction projects management (Obras)
 */

import { useEffect } from 'react';
import { MainLayout } from "@/components/MainLayout";
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';

export default function ConstructionWorksPage() {
  useEffect(() => {
    document.title = 'Todas as Obras | Controle Financeiro';
  }, []);

  return (
    <MainLayout>
      <div className="container mx-auto py-6">
        <AllProjectsPage
          domain={CompanyType.CONSTRUCTION}
          title="Todas as Obras"
          description="Gerencie suas obras e projetos de construção"
          createButtonLabel="Nova Obra"
        />
      </div>
    </MainLayout>
  );
}
